import React from "react";

import styled from "styled-components";
import {subduedTextColour} from "../../../style/styleConsts";

const Container = styled.div`
    margin-left: 30px;
`;

export const Label = styled.div`
    color: ${props => props.color};
    white-space: nowrap;
`;

export const ValueContainer = styled.div`
    white-space: nowrap;
`;

export const MetricValue = styled.div`
    font-weight: bold;
    font-size: 26px;
`;

const Metric = ({label, color = subduedTextColour, children}) => (
    <Container>
        <Label color={color}>{label}</Label>
        <ValueContainer>{children}</ValueContainer>
    </Container>
);

export default Metric;
